import { render, staticRenderFns } from "./androidYearChange.vue?vue&type=template&id=4ddba1e0&scoped=true&"
import script from "./androidYearChange.vue?vue&type=script&lang=js&"
export * from "./androidYearChange.vue?vue&type=script&lang=js&"
import style0 from "./androidYearChange.vue?vue&type=style&index=0&id=4ddba1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddba1e0",
  null
  
)

export default component.exports